import React from 'react';
import PropTypes from 'prop-types';
import { Cloud, KeyRound } from 'lucide-react';
import useTheme from 'hooks/useTheme';
import aaguidIcons from 'utils/auth/passkeyAaguidIcons.json';

// aaguid identifies which authenticator created a passkey (owner-api returns it
// per credential - see WebauthnCredential.aaguid / PasskeyUtils.toPasskeySummary).
// aaguidIcons.json is a small, hand-curated subset (real vendor icons, light/dark
// variants) of the community-maintained passkeydeveloper/passkey-authenticator-
// aaguids registry - not the full ~373-entry registry, kept small on purpose for
// bundle size. That project's own README warns the full list "could go away at
// any time" (retired entries become an empty object), so an unrecognized or
// missing aaguid - including a wholesale removal upstream - always falls back to
// a generic icon here, never breaks.
const PasskeyPlatformIcon = ({ aaguid, backedUp, size = 18, className = '' }) => {
  const theme = useTheme();
  const entry = aaguid ? aaguidIcons[aaguid.toLowerCase()] : undefined;

  if (entry) {
    const src = theme === 'dark' ? entry.icon_dark : entry.icon_light;
    return <img src={src} alt={entry.name} width={size} height={size} className={className} />;
  }

  // Generic fallback: distinguishes an account-synced passkey from a
  // single-device one, rather than showing the same icon regardless.
  const GenericIcon = backedUp ? Cloud : KeyRound;
  return <GenericIcon size={size} className={className} aria-hidden />;
};

PasskeyPlatformIcon.propTypes = {
  aaguid: PropTypes.string,
  backedUp: PropTypes.bool,
  size: PropTypes.number,
  className: PropTypes.string,
};

export default PasskeyPlatformIcon;
